<template>
  <div class="main-content">
    <section class="section">
      <PageHeaderNoAction></PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
          <div class="card-header">
              <h4>{{$helper.getWord('Account detail')}}</h4>
          </div>
          <div class="card-body">
            <form>
              <div class="form-group">
                 <div class="row">
                <div class="col-6">
              <label >{{$helper.getWord('Subscription ID')}}</label>
              <input type="text" class="form-control" v-model="subscription_id"  readonly/>
               </div>
                 <div class="col-6">
                  <label >{{$helper.getWord('Expiry date')}}</label>
              <input type="text"  class="form-control" v-model="expiry_date" readonly/>
            </div>
            </div>
            </div>
              <div class="form-group">
                <div class="row">
                <div class="col-6">
                  <label >{{$helper.getWord('Last Name')}}</label>
              <input type="text"  class="form-control" v-model="last_name" required/>
                </div>
                <div class="col-6">
                  <label >{{$helper.getWord('First Name')}}</label>
              <input type="text"  class="form-control" v-model="first_name" required/>
            </div>
                </div>
                </div>
            <div class="form-group">
              <label>{{$helper.getWord('Position')}}</label>
              <input type="text" class="form-control" v-model="position" required readonly/>
            </div>
            <div class="form-group">
              <label>{{$helper.getWord('email')}}</label>
              <input type="email" class="form-control"  aria-describedby="emailHelp" v-model="email" required >
              <small id="emailHelp" class="form-text text-muted"></small>
              <div class="correctname" v-if="saved">saved</div>
            </div>
            <div class="form-group">
              <div class="row">
                <div>
            <button class="btn btn-primary mr-2" @click="saveuser()" v-if="!changebtu">{{$helper.getWord('Save')}}</button>
                </div>
                <p>&nbsp;&nbsp;</p>
                <div>
             <button class="btn btn-primary mr-2" @click="showform()" v-if="!changebtu">{{$helper.getWord('Change Password')}}</button>
                </div>
                <div>
             <button class="btn btn-primary" @click="showusername()" v-if="!changebtu">{{$helper.getWord('Change username')}}</button>
                </div>
              </div>
            </div>
            <div v-if="showname">
            <div class="form-group">
              <label >{{$helper.getWord('New UserName')}}</label>
              <input type="text" ref="cusername" class="form-control" v-model="username" @blur="checkusernameexist()" required />
              <div class="errormsg" v-if="usernamecannotuse">{{$helper.getWord('usernamecannotuse')}}</div>
              <div class="errormsg" v-if="haveSpecialCharacters">{{$helper.getWord('haveSpecialCharacter')}}</div>
              <div class="correctname" v-if="usernamecanuse">{{$helper.getWord('usernamecanuse')}}</div>
            </div>
            <div class="form-group">
              <label >{{$helper.getWord('Password')}}</label>
              <input type="password" ref="cpassword" class="form-control" v-model="password" required />
            </div>
            <div>
            <button class="btn btn-primary mr-2" @click="saveusername()" v-if="!changebtu">{{$helper.getWord('Save')}}</button>
                </div>
            </div>
            <div v-if = changebtu>
            <div class="form-group">
              <label >{{$helper.getWord('Password')}}</label>
              <input type="password" ref="cpassword" class="form-control" v-model="password" required />
            </div>
            <div class="form-group">
              <label >{{$helper.getWord('New Password')}}</label>
              <input type="password" ref="newpassword" class="form-control" v-model="newpassword" required />
            </div>
             <div class="form-group">
              <label >{{$helper.getWord('Confirm New Password')}}</label>
              <input type="password" ref="checkpassword" class="form-control" v-model="confirmpassword" required />
            </div>
            <div class="correctname" v-if="changed">{{$helper.getWord('Changed')}}</div>
            <button class="btn btn-primary" @click="changepassword()">{{$helper.getWord('Change Password')}}</button>
            </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "@/api";
import helper from "@/vueHelper";
import config from "@/config";
export default {
    title: helper.getWord("Account detail"),
    name:"changepassword",
    access_code: "F_LIST02",
    hidden:true,
    excludeSideBar:true,
  data(){
      return{
        last_name:"",
        first_name:"",
        position:"",
        username:"",
        oldusername:"",
        email:"",
        password:"",
        newpassword:"",
        confirmpassword:"",
        changebtu:false,
        haveSpecialCharacters:false,
        usernamecannotuse:false,
        usernamecanuse:false,
        saved:false,
        changed:false,
        showname:false,
        subscription_id:"",
        expiry_date:""
      }
  },
  methods:{
    saveusername(){
      api.request(
          this,
          "post",
          "/system/getuser",
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            Parameters: {
              getuser:false,
              saveuser:false,
              chpassword:true,
              username:this.username,
              oldusername:this.oldusername,
              password:this.password,
            }
          },

          function(r) {
            if(r.data.saved=="saved"){
              this.saved=true;
            }
          });
    },
    showusername(){
      this.showname=true;
    },
    showform(){
      this.changebtu=true;
    },
    saveuser(){
      api.request(
          this,
          "post",
          "/system/getuser",
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            Parameters: {
              getuser:false,
              saveuser:true,
              last_name:this.last_name,
              first_name:this.first_name,
              position:this.position,
              email:this.email,
              
            }
          },

          function(r) {
            if(r.data.saved=="saved"){
              this.saved=true;
            }
          });
    },
    checkusernameexist(){
        if(!this.username || this.username==this.oldusername){
          
        }else if(this.containsSpecialCharacters(this.username)==true){
          this.haveSpecialCharacters=true;
        }else if(this.containsSpecialCharacters(this.username)==false){
          var vm=this;
          $.ajax({
             type: "POST",
             url: config.serverURI + '/api/system/checkusernameexist',
             headers: {
                    "Content-type": "application/json; charset=utf-8"
                  },
             data: JSON.stringify(
                {
                      SessionID: helper.getSessionID(),
                      LocaleCode: helper.getLocaleCode(),
                      Parameters: {
                        username:this.username,
                      },
                      ApiKey: config.apiKey,
                      ApiSystemName: config.apiSystemName
                    }
              ),
             dataType:"json",
             success: function(r) {
            var userstatus=r.data.userstatus;
            if(userstatus=="alreadyhave"){
              vm.usernamecannotuse= true;
              vm.usernamecanuse=false;
              vm.haveSpecialCharacters=false;
            }else if(userstatus=="nouser"){
              vm.usernamecanuse= true;
              vm.usernamecannotuse=false;
              vm.haveSpecialCharacters=false;
            }
             }
          });
         }
       },
      containsSpecialCharacters(str){
          var regex = /[ !@#$%^&*()+\-=\[\]{};':"\\|,<>\/?]/g;
        	return regex.test(str);
        },
        changepassword(){
          if(this.newpassword == this.confirmpassword){
          var vm=this;
          api.request(
          this,
          "post",
          "/system/getuser",
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            Parameters: {
              getuser:false,
              saveuser:false,
              chpassword:true,
              username:this.username,
              password:this.password,
              oldusername:this.oldusername,
              newpassword:this.newpassword,
              confirmpassword:this.confirmpassword
            }
          },
          function(r) {
            this.password="";
            this.newpassword="";
            this.confirmpassword="";
            if(r.data.changed=="changed"){
              vm.changed=true;
            }
          });
          }else{
            alert("The password is not same");
          }
        }
  },
  mounted(){
    api.request(
          this,
          "post",
          "/system/getuser",
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            Parameters: {
              getuser:true,
              saveuser:false
            }
          },

          function(r) {
            this.last_name=r.data.last_name;
            this.first_name=r.data.first_name;
            this.position=r.data.position;
            this.username=r.data.username;
            this.oldusername = r.data.username;
            this.email=r.data.email;
            this.subscription_id = r.data.subscription_id;
            this.expiry_date = r.data.expiry_date;
          });
  }
}
</script>

<style>
.section-body {
  padding-top: 100px;
}
.errormsg {
  width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #dc3545;
}
.correctname {
  width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #22b60e;
}
</style>